import { SettingsLayout } from 'modules/settingsContainer/SettingsLayout';
import { DataTab } from 'modules/filters/Multiple/settings/DataTab';

export const MultipleFilterMainSettings = () => {
  return (
    <SettingsLayout>
      <DataTab />
    </SettingsLayout>
  );
};
